import axios from 'axios';
import { ConferenceExistsModel, DCPBranding, DCPConference, StartDCPConference, PastConference, ConferenceDetails, EventLogEntry } from '@/models/DCPConference';

/**
 * API calls for DCP-Moderator-Service
 * @module service/DCPModeratorService
 */
export default {
	// API Calls
	getDCPConferences(): Promise<DCPConference[]> {
		return axios.get('/dcp/moderator').then((res) => res.data);
	},
  startDCPConference(data: StartDCPConference): Promise<DCPConference> {
    return axios.post('/dcp/moderator', data).then((res) => res.data);
  },
  stopDCPConference(id: string): Promise<void> {
    return axios.post('/dcp/moderator/stop', { id }).then((res) => res.data);
  },
  getDCPBrandings(): Promise<DCPBranding[]>{
    return axios.get('/dcp/branding').then((res) => res.data);
  },
  getDCPConference(id: string): Promise<DCPConference> {
    return axios.get(`/dcp/moderator/${id}`).then((res) => res.data);
  },
  checkConferenceExists(pin: string): Promise<ConferenceExistsModel> {
    return axios.get(`/dcp/participant/${pin}`).then((res) => res.data);
  },
  registerPinAndKey(pin: string, key: string): Promise<void> {
    return axios.post(`/dcp/participant/register/${pin}/${key}`).then((res) => res.data);
  },
  getPastConferences(): Promise<PastConference[]> {
    return axios.get('/dcp/moderator/past').then((res) => res.data);
  },
  getConferenceDetails(confId: string): Promise<ConferenceDetails> {
    return axios.get(`/dcp/moderator/${confId}/details`).then((res) => res.data);
  },
  getEventLogs(confId: string): Promise<EventLogEntry[]> {
    return axios.get(`/dcp/moderator/${confId}/event-logs`).then((res) => res.data);
  }
};
